'use client';

// Spanish copy of components/platformHero for /es/platforms/<slug> (DEV-15362,
// ES batch 2). Same layout and styles.
import React from 'react';
import Image from 'next/image';
import { StyledPlatofrmHero } from '../platformHero/platformHero.styles';
import { IPlatform } from '../../types';

interface IPlatformHeroEsProps {
    platform: Pick<IPlatform, 'title' | 'icon' | 'subTitle'>;
    appWord: string;
    siteWord: string;
}

export const PlatformHeroEs = ({ platform, appWord, siteWord }: IPlatformHeroEsProps) => {
    return (
        <StyledPlatofrmHero>
            <div className="hero-wrapper">
                <div className="platform-img-wrapper">
                    <Image src={platform.icon} alt={platform.title} fill />
                </div>
                <h1>
                    <span>{appWord.charAt(0).toUpperCase() + appWord.slice(1)}s</span> para {platform.title} de Common Ninja
                </h1>
                <h2>
                    {platform.subTitle ||
                        `Lleva tu ${siteWord} de ${platform.title} al siguiente nivel con nuestra amplia colección de ${appWord}s potentes. Adelántate a la competencia: mejora el diseño de tu ${siteWord}, la experiencia de usuario y la visibilidad de tus productos, y aumenta tus ventas.`}
                </h2>
            </div>
        </StyledPlatofrmHero>
    );
};
